import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class BalanceService {
    constructor() {
    }

    handleCompare(compareData: any, keyMappings: object, keyCompares: object){
        let arr1 = JSON.parse(JSON.stringify(compareData.arr1));
        let arr2 = JSON.parse(JSON.stringify(compareData.arr2));
        let result = {
            joint: [],
            notJoint: []
        };
        arr1.forEach( i => {
            let test = arr2.filter( ii => {
                let crs = true;
                for (let key in keyMappings){
                    if(typeof i[key] == 'undefined' || typeof ii[keyMappings[key]] == 'undefined'){
                        crs = false;
                        break;
                    }
                    if(i[key] != ii[keyMappings[key]]){
                        crs = false;
                        break;
                    }
                }
                return crs;
            });
            if(test.length > 0){
                let crs = true;
                for (let key in keyCompares){
                    if(typeof i[key] == 'undefined' || typeof test[0][keyCompares[key]] == 'undefined'){
                        crs = false;
                        break;
                    }
                    if(i[key] != test[0][keyCompares[key]]){
                        crs = false;
                    }
                }
                crs == true ? result.joint.push({a: i, b: test[0]}) : result.notJoint.push({a: i, b: test[0]});
            }else{
                result.notJoint.push({
                    a: i,
                    b: null,
                })
            }
        });
        arr2.forEach(ii => {
            let test = arr1.filter( i => {
                let crs = true;
                for (let key in keyMappings){
                    if(typeof i[key] == 'undefined' || typeof ii[keyMappings[key]] == 'undefined'){
                        crs = false;
                        break;
                    }
                    if(i[key] != ii[keyMappings[key]]){
                        crs = false;
                        break;
                    }
                }
                return crs;
            });
            if(test.length == 0){
                result.notJoint.push({
                    a: null,
                    b: ii
                })
            }
        });
        return result;
    }


    /* VNPay */
    getAllRecord(data, keyWizard){
        let result = [];
        data.forEach(record => {
            let checkRecord = this.checkRecord(record, keyWizard);
            if (checkRecord.status) {
                result.push(checkRecord.value);
            }else{
                console.log('err',checkRecord.value);
            }
        });
        return result;
    }
    checkRecord(record, keyWizard: any){
        let result = {
            status: false,
            value: {},
        };
        for (let k in keyWizard) {
            let index = keyWizard[k].index;
            if(typeof record[index] != "undefined" && keyWizard[k].validator(record[index])){
                result.value[k] = record[index];
            }else{
                if(typeof keyWizard[k].required == 'undefined' || keyWizard[k].required == false){
                    result.value[k] = null;
                }else{
                    result.value = record;
                    return result;
                }
            }
        }
        result.status = true;
        return result;

    }
}